import { Article, User } from '../types';
import { ArticleService } from './articleService';
import { assertPublicationCompatibleText } from '../utils/publicationText';

export class PublicationService {
  // The article and its durable publication request are persisted in one write.
  static prepare(payload: unknown): Partial<Article> {
    assertPublicationCompatibleText(payload);
    const publicationPayload = JSON.stringify(payload);
    if (!publicationPayload || publicationPayload.length > 1000000) {
      throw new Error('Der Veröffentlichungsauftrag ist zu groß oder unvollständig.');
    }
    const publicationRequestId = Array.from(crypto.getRandomValues(new Uint8Array(16)), byte => byte.toString(16).padStart(2, '0')).join('');
    return { publicationState: 'queued', publicationRequestId, publicationPayload, publicationError: '' };
  }

  static async enqueue(article: Article, payload: unknown, user: User, updates: Partial<Article> = {}): Promise<Article> {
    const current = await ArticleService.getArticle(article.id, user);
    if (current.status === 'published' || ['queued', 'sending', 'accepted', 'uncertain'].includes(current.publicationState || '')) {
      throw new Error('Für diesen Artikel besteht bereits ein Veröffentlichungsauftrag.');
    }
    return ArticleService.updateArticle(article.id, { ...updates, ...this.prepare(payload) }, user);
  }
}
